<template>
    <BreadCrumb PageTitle="Ajouter un type de paiement de fret" />
    <AddModalTypeFretPaie/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
     import AddModalTypeFretPaie from "@/components/TypeFretPaiement/AddModalTypeFretPaie.vue";
  
    export default defineComponent({
      name: "AddTypeFrePaiePage",
      components: {
        BreadCrumb,
        AddModalTypeFretPaie,
      },
    });
  </script>